import AbsenceUserArchive from 'features/absence/absenceUserArchive';
import { useTitle } from '../helpers';

/**
 * @page Absence user archive page
 */
const AbsenceUserArchivePage = () => {
  useTitle('Информация о неявке в архиве');

  return (
    <div>
      <h3>Страница информации о неявке в архиве</h3>
      <AbsenceUserArchive />
    </div>
  );
};

export default AbsenceUserArchivePage;
